import { Box, Button, CircularProgress, Container, Grid, IconButton, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Redirect } from 'react-router-dom';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

class Reportes extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            consultaRealizada: false,
            reporte: {
                codigoReporte: '',
                anio: '',
                lugar: '',
                lugarCentral: '',
            },
            lugaresTra: [],
            ubicacionesCentral: [],
            datosReporte: [],
            errores: null,
            notificaciones: null,
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEnvioConsulta = this.manejarEnvioConsulta.bind(this);
    }

    async componentDidMount(){

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });


        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });
    }

    render(){
        return (
            <>
                <h3>Reportes</h3>
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.consultaRealizada
                ?
                    <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                    </ReactHtmlTableToExcel> 

                :
                    <Container>
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        <Box sx={{ flexGrow: 1}} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={2.5}>
                                    <Item>Mes</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigoReporte'  value={this.state.reporte.codigoReporte} onChange={this.manejarCambiosDatos}>
                                        <option value=''>REPORTE</option>
                                        {/*<option value='1'>FUNCIONARIOS POR LUGAR DE TRABAJO</option>
                                        <option value='2'>SALDO FUNCIONARIOS</option>*/}
                                    </select>
                                </Grid>
                                {this.state.reporte.codigoReporte !== ''
                                ?
                                    <Grid item xs={2}>
                                        <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioConsulta}>Enviar</button>
                                    </Grid>
                                :
                                    null
                                }
                                <Grid item xs={3.5}>

                                </Grid>
                                <Grid item xs={2.5}>
                                    {(this.state.reporte.codigoReporte === '1') || (this.state.reporte.codigoReporte === '2')
                                    ?
                                        <Item>Lugar</Item>
                                    :
                                        null
                                    }
                                </Grid>
                                <Grid item xs={2}>
                                    {(this.state.reporte.codigoReporte === '1') || (this.state.reporte.codigoReporte === '2')
                                    ?
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='lugar'  value={this.state.reporte.lugar} onChange={this.manejarCambiosDatos}>
                                            <option value=''>UBICACION</option>
                                            {this.state.lugaresTra.map((name) =>
                                                <option
                                                key={name.idLugaresTrabajo}
                                                value={name.idLugaresTrabajo}
                                                >{name.lugar}</option>
                                                )}
                                        </select>
                                    :
                                        null
                                    }
                                </Grid>
                                <Grid item xs={2.5}>
                                    {((this.state.reporte.codigoReporte === '1') || (this.state.reporte.codigoReporte === '2')) && (this.state.reporte.lugar === '0')
                                    ?
                                        <Item>OFICINA</Item>
                                    :
                                        null
                                    }
                                </Grid>
                                <Grid item xs={2}>
                                    {((this.state.reporte.codigoReporte === '1') || (this.state.reporte.codigoReporte === '2')) && (this.state.reporte.lugar === '0')
                                    ?
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='lugarCentral'  value={this.state.reporte.lugarCentral} onChange={this.manejarCambiosDatos}>
                                            <option value=''>UBICACION</option>
                                            {this.state.ubicacionesCentral.map((name) =>
                                                <option
                                                key={name.idUbicacionesCentral}
                                                value={name.idUbicacionesCentral}
                                                >{name.descripcion}
                                            </option>
                                                )}
                                        </select>
                                    :
                                        null
                                    }
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                }

                {this.state.consultaRealizada
                ?
                    this.state.reporte.codigoReporte === '1'
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper} >
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Numero Funcionario</StyledTableCell>
                                            <StyledTableCell>Nombre</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datosReporte.map((dato, index) => (
                                                <StyledTableRow key={index}>
                                                    <StyledTableCell width={'20%'}>{dato.numeroFuncionario}</StyledTableCell>
                                                    <StyledTableCell>{dato.primerNombre + ' ' + dato.primerApellido}</StyledTableCell>
                                                </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Container>
                    :
                        null
                :
                    null
                }
            </>
        )
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const numFunActualizado = state.reporte;
            numFunActualizado[clave] = valor;
            return{
                reporte: numFunActualizado,
            };
        });
    }
    async manejarEnvioConsulta(e){
        e.preventDefault();
        if((this.state.reporte.codigoReporte === '')){
            this.setState({
                errores: 'DEBE INGRESAR EL TIPO DE REPORTE',
            });
        }else{
            this.setState({
                loading: true,
            })
            const cargaUtil = JSON.stringify([this.state.reporte]);
            const respuesta = await fetch(`${Constantes.RUTA_API}/reportes.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();
            this.setState({
                errores: exito[0],
            })

            if(exito[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: null,
                    datosReporte: exito[1],
                    //consultaRealizada: true,
                    loading: false,
                })
            }
        }
    }
}

export default Reportes